import {
  VStack,
  useResponsive,
  Image,
  getCdnImageSrc,
  ColorIcon,
  colors,
  HStack,
  responsive,
  NextLink,
  LargeButton,
  LARGEL_BUTTON_TYPE,
} from "goi_common";
import { Box, Stack } from "@chakra-ui/react";
import { ReactNode } from "react";
import { MAX_WIDTH } from "@/constants/components";

export default function AboutSection() {
  return (
    <>
      <VStack width="100%" alignItems="center" background={colors.brown850}>
        <VStack
          maxWidth={`${MAX_WIDTH}px`}
          gap={"40px"}
          css={responsive({
            padding: { base: "0 24px 64px", lg: "0px 24px 120px" },
          })}
        >
          <Box
            className="head_24_eb lg_head_42_b"
            css={responsive({
              padding: { base: "70px 0 0", lg: "120px 0 0px" },
              color: colors.white,
              textAlign: "center",
            })}
          >
            고객님의 납입금은 안전하게,
            <br />
            해지는 위약금 없이 자유롭게
          </Box>
          <AboutItem
            num={1}
            secondContent={{
              title: (
                <Box>
                  고이는 고객의 돈을
                  <br />
                  안전하게 보관해요.
                </Box>
              ),
              description:
                "고이는 업계 최초 벤처 투자 유치 등을 통해 \n안정적으로 운영 중입니다. 또한, 고객님의 불안을 해소하기 위해 월 100원이라는 최소한의 선수금만 받고 있습니다.",
            }}
          />
          <AboutItem
            num={2}
            secondContent={{
              title: (
                <Box>
                  고이는 중도 해지 시<br />
                  100% 환급해 드려요.
                </Box>
              ),
              description:
                "고이는 복잡한 산식 대신 누적 납입금 전액을\n전액 투명하게 환급해 드립니다.",
            }}
          />
        </VStack>
      </VStack>
      <VStack width="100%" alignItems="center" background={colors.orange50}>
        <VStack
          maxWidth={`${MAX_WIDTH}px`}
          gap={"40px"}
          css={responsive({
            padding: { base: "0 24px 64px", lg: "0px 24px 120px" },
          })}
        >
          <Box
            className="head_24_eb lg_head_42_b"
            css={responsive({
              padding: { base: "70px 0 0", lg: "120px 0 40px" },
              color: colors.gray900,
              textAlign: "center",
            })}
          >
            우리 가족의 마지막 순간인 장례,
            <br />
            <b className="orange650">투명하고 정직한 서비스</b>를{" "}
            <br className="lg_over_hidden" />
            고집합니다.
          </Box>

          <AboutMobileBackgroundItem
            num={3}
            secondContent={{
              title: (
                <Box>
                  고이는 <br className="lg_over_hidden" />
                  투명하고 정직한 장례를 위한
                  <br />
                  3가지 약속을 지키고 있어요.
                </Box>
              ),
              description: (
                <VStack gap={"14px"}>
                  <AboutBadgeDescription
                    num={1}
                    description="업계 최초 품목별 가격 정찰제"
                  />
                  <AboutBadgeDescription
                    num={2}
                    description="미 사용품 100% 현금 공제"
                  />
                  <AboutBadgeDescription
                    num={3}
                    description="서비스 불만족시 100% 환불 정책"
                  />
                </VStack>
              ),
            }}
          />
          <VStack width="100%" alignItems="center" padding="12px 0 0">
            <NextLink
              href={"/content/feeds/about-promise/"}
              css={responsive({
                width: "260px",
              })}
              event={{
                newGtm: { path: "home", trigger_and_target: "uv_service" },
              }}
            >
              <LargeButton
                buttonType={LARGEL_BUTTON_TYPE.ORANGE}
                className="subtitle_18_b"
                css={responsive({
                  borderRadius: "8px",
                  height: "52px",
                })}
              >
                고이의 약속 자세히 보기
              </LargeButton>
            </NextLink>
          </VStack>
        </VStack>
      </VStack>
    </>
  );
}

function AboutItem({
  num,

  secondContent,
}: {
  num: number;

  secondContent: { title: ReactNode; description: string };
}) {
  return (
    <VStack gap="64px">
      <Stack
        justifyContent="space-between"
        background={colors.white}
        backgroundSize="cover"
        backgroundPosition="center"
        css={responsive({
          padding: { base: "28px 20px", lg: "60px" },
          borderRadius: { base: "8px", lg: "16px" },
          flexDirection: { base: "column", lg: "row" },
          gap: { base: "24px", lg: "36px" },
        })}
      >
        <VStack
          justifyContent="center"
          css={responsive({
            width: { base: "100%", lg: "50%" },
          })}
        >
          <ColorIcon
            name="icon-shield-check-mono"
            size={36}
            color={colors.brown300}
          />
          <Box
            className="subtitle_21_eb lg_head_32_b"
            color={colors.brown400}
            css={responsive({
              padding: { base: "8px 0", lg: "16px 0 40px" },
            })}
          >
            {secondContent.title}
          </Box>
          <Box
            className="body_16_r lg_subtitle_21_r"
            color={colors.brown400}
            css={{ wordBreak: "keep-all", whiteSpace: "pre-line" }}
          >
            {secondContent.description}
          </Box>
        </VStack>

        <VStack
          css={responsive({
            width: { base: "100%", lg: "50%" },
            height: { base: "100%", lg: "366px" },
          })}
          borderRadius="16px"
        >
          <Image
            src={getCdnImageSrc(
              num === 2
                ? `direct/home/negative-about-des.png`
                : `direct/home/about-des-2-${num}.png`
            )}
            width="100%"
            height="auto"
            alt=""
          />
        </VStack>
      </Stack>
    </VStack>
  );
}

function AboutMobileBackgroundItem({
  num,

  secondContent,
}: {
  num: number;

  secondContent: { title: ReactNode; description: ReactNode };
}) {
  const { isBiggerThanLg } = useResponsive();
  return (
    <VStack gap="64px" id="about-promise" css={{ scrollMarginTop: "100px" }}>
      <Stack
        justifyContent="space-between"
        css={responsive({
          padding: { base: "28px 20px", lg: "40px" },
          borderRadius: { base: "8px", lg: "16px" },
          flexDirection: { base: "column", lg: "row" },
          gap: { base: "24px", lg: "36px" },
          background: {
            base: `linear-gradient(258deg, rgba(255, 255, 255, 0.00) -60.52%, #FFF 75.45%),url(${getCdnImageSrc(
              `direct/home/about-des-${num}.png`
            )})`,
            lg: colors.white,
          },
          boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.08)",
          width: { base: "calc(100vw - 48px)", lg: "100%" },
        })}
        backgroundSize="cover"
        backgroundPosition="center"
      >
        <VStack
          justifyContent="center"
          css={responsive({
            width: { base: "100%", lg: "50%" },
          })}
        >
          <ColorIcon
            name="icon-shield-check-mono"
            size={36}
            color={colors.brown300}
          />
          <Box
            className="subtitle_21_eb lg_head_32_b"
            color={colors.brown400}
            css={responsive({
              padding: { base: "8px 0 21px", lg: "16px 0 40px" },
            })}
          >
            {secondContent.title}
          </Box>

          <Box
            className="body_14_r lg_subtitle_21_r"
            color={colors.brown400}
            css={{ wordBreak: "keep-all", whiteSpace: "pre-line" }}
          >
            {secondContent.description}
          </Box>
        </VStack>

        {isBiggerThanLg && (
          <VStack
            borderRadius="16px"
            css={responsive({
              width: { base: "100%", lg: "50%" },
              height: { base: "100%", lg: "510px" },
            })}
          >
            <Image
              src={getCdnImageSrc(`direct/home/about-des-${num}.png`)}
              width="100%"
              height="100px"
              alt=""
            />
          </VStack>
        )}
      </Stack>
    </VStack>
  );
}

function AboutBadgeDescription({
  num,
  description,
}: {
  num: number;
  description: string;
}) {
  const { isBiggerThanLg } = useResponsive();
  return (
    <HStack gap={isBiggerThanLg ? "16px" : "6px"} alignItems="center">
      <Box
        className="orange650"
        fontWeight={600}
        background={colors.orange250}
        borderRadius="5px"
        css={responsive({
          fontSize: { base: "12px", lg: "21px" },
          padding: { base: "1px 8px", lg: "6px 12px" },
        })}
      >
        0{num}
      </Box>
      <Box className="subtitle_16_sb lg_head_24_b">{description}</Box>
    </HStack>
  );
}
